import type { ParticipanteBusquedaPrefillResolveReason } from './participanteBusquedaPrefillResolve.ts';

export function participanteBusquedaFailureMensaje(
  reason: Exclude<ParticipanteBusquedaPrefillResolveReason, 'empty'>,
  copy: { notFound: string; ambiguous: string },
): string {
  return reason === 'ambiguous' ? copy.ambiguous : copy.notFound;
}
